export enum SystemActions {
  read_loans_p2p = 'read.loans.p2p',
  create_loans_p2p = 'create.loans.p2p',
  edit_loans_p2p = 'edit.loans.p2p',
  read_warehouses = 'read.warehouses',
  create_warehouses = 'create.warehouses',
  edit_warehouses = 'edit.warehouses',
  read_drawers = 'read.drawers',
  create_drawers = 'create.drawers',
  edit_drawers = 'edit.drawers',
  read_drawers_divisions = 'read.drawers_divisions',
  read_comments = 'read.comments',
  create_comments = 'create.comments',
  edit_comments = 'edit.comments',
  delete_comments = 'delete_comments',
  read_keys = 'read.keys',
  create_keys = 'create.keys',
  edit_keys = 'edit.keys',
  read_type_keys = 'read.type_keys',
  read_users = 'read.users',
  create_users = 'create.users',
  edit_users = 'edit.users',

  read_loans = 'read.loans',
  read_loans_by_session = 'read.loans_by_session',
  delete_loans = 'delete.loans',
  create_loans = 'create.loans',
  edit_loans = 'edit.loans',
  read_loans_keys_by_user = 'read.loans_keys_by_user',
  read_properties = 'read.properties',
  create_properties = 'create.properties',
  edit_properties = 'edit.properties',
  read_problems = 'read.problems',
  carga_masiva = 'carga_masiva',
  read_dashboard = 'read.dashboard',
  login = 'login',
  register = 'register',
}
